// extracted by mini-css-extract-plugin
export var footer = "_oi-0";
export var inherit = "_oi-1";
export var input = "_oi-2";
export var modalContent = "_oi-3";
export var quillEditor = "_oi-4";
export var subtitle = "_oi-5";